import api from "../../../../service/api";

const ERAPayer = async () => {
  let path = "clearing-house/era-payer/";
  return api.get(path);
};

const UploadERA = async (data) => {
  let path = "clearing-house/era-upload/";
  return api.post(path, data);
};


const GetEraListData = async (practicePK, qry) => {
  let path = "clearing-house/era-listing/"; //?practice_pk='+ practicePK;
  if (qry) path += qry;
  return api.get(path);
};

const EraAdjustmentType = async (headerPK) => {
  let path =
    "clearing-house/era-payment-adjustment-type/?header_pk=" + headerPK;
    return api.get(path);
};

const GetHeader = async (headerPK) => {
  let path = "clearing-house/era-payment-header/" + headerPK;
  return api.get(path);
};

const GetClaimDataSummary = async (qry) => {
  let path = "clearing-house/era-payment-review-summary/?" + qry;
  return api.get(path);
};

const GetClaimData = async (qry) => {
  let path = "clearing-house/era-payment-review/?" + qry;
  return api.get(path);
};

const GetProcedureDataForManuallyAdded = async (query) => {
  let path = 'clearing-house/era-payment-claim-procedures/' + query;
  return api.get(path);
};


const ListClaimStatusSubStatus = async (pageSize, page, practicePK) => {
  let path = null;
  path = 'practice/claim-status-sub-status/?page_size=' + pageSize + '&page=' + page + '&practice_pk=' + practicePK ;
  return api.get(path);
}

const addClaimToEraManually = async (data) => {
  let path = "clearing-house/era-payment-claims/";
  return api.post(path, data);
};


const ListClaimStatus = async (
  pageSize,
  page,
  practicePK,
  listType,
  patientPK,
  claimPK
) => {
  let path = null;
  path =
    "practice/claim-status/?page_size=" +
    pageSize +
    "&page=" +
    page +
    "&practice_pk=" +
    practicePK +
    "&list_type=" +
    listType;
  if (patientPK) path += "&patient_pk=" + patientPK;
  if (claimPK) path += "&opened_claim_pk=" + claimPK;
  return api.get(path);
};


const GetListAdjustmentReasonCode = async (
  pageSize,
  page,
  searchValue,
  listType
) => {
  let path =
    "practice/reason-code/?page_size=" +
    pageSize +
    "&page=" +
    page +
    "&list_type=" +
    listType;
  if (searchValue) path += "&search=" + searchValue + "&name_search=True";
  return api.get(path);
};


const ClaimsDropdownForERAManualAdd = async (query, practice_pk) => {
  let path =
    "claim/claims/" +
    "?drop_down=true" +
    "&search=" + query +
    "&page=0" +
    "&patient_pk=" +
    "&practice_pk=" + practice_pk;  
    return api.get(path);
};

const GetClaimDataForEraManualAdd = async (query, practice_pk) => {
    let path =
    "claim/claims/" +
    "?practice_pk=" + practice_pk +
    "&claim_id=" + query +
    "&active=1" +
    "&list=true"
    return api.get(path);
};

const UpdateERA = async (headerPK,data) => {
  let path = "clearing-house/era-payment-header/" + headerPK;
  return api.put(path,data);
};

const MakeAsReviewed = async (id, data) => {
  let path = "clearing-house/mark-as-reviewed/" + id + "/";
  return api.put(path, data);
};

const RemoveEraFromList = (id) => {
  let path = "clearing-house/remove-era-claim/" + id + "/"
  return api.destroy(path);
}

const EraModalSave = async (id,data) => {
  let path = "clearing-house/save-era-procedure/" + id + "/"
  return api.put(path,data)
}

const SaveInsurancePaymentProceduresFromERAPosting = async (data) => {
  let path = "clearing-house/era-payment-apply/";
  return api.post(path, data);
};

const ExportERAList = async (data) => {
  let path = "clearing-house/era-list-export/";
  return api.post(path, data);
};


const GetERAPaymentExport = async (qry) => {
  let path = "clearing-house/era-payment-export/" + qry;
  return api.getXLS(path);
};

const exportERAPDF = async (qry) => {
  let path = "clearing-house/era-payment-export/" + qry;
  return api.get(path);
};

const GetPresignedEraURL = async (data) => {
  const result = await api.post('clearing-house/download-era-file/', data);
  return result;
}

export default {ERAPayer,UploadERA,GetEraListData,EraAdjustmentType,GetHeader,GetClaimDataSummary,EraModalSave,
  GetClaimData,GetProcedureDataForManuallyAdded,ListClaimStatusSubStatus,ListClaimStatus,GetListAdjustmentReasonCode,
  ClaimsDropdownForERAManualAdd,GetClaimDataForEraManualAdd,addClaimToEraManually,UpdateERA,MakeAsReviewed,RemoveEraFromList,
  SaveInsurancePaymentProceduresFromERAPosting,ExportERAList,GetERAPaymentExport,exportERAPDF,GetPresignedEraURL
}